import { render, staticRenderFns } from "./update-department.vue?vue&type=template&id=0663a587&scoped=true&"
import script from "./update-department.vue?vue&type=script&lang=js&"
export * from "./update-department.vue?vue&type=script&lang=js&"
import style0 from "./update-department.vue?vue&type=style&index=0&id=0663a587&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0663a587",
  null
  
)

export default component.exports